import { getMarketingConsent, isMarketingPath } from './consent';
import { trackGaConversion } from './googleAnalytics';

/**
 * Eventos estándar de Meta Pixel (Contact / Lead / Schedule).
 *
 * Solo se envían si el Pixel ya está cargado (consentimiento + host de producción,
 * ver MetaPixel.tsx) y la ruta actual está en la allowlist de marketing.
 * Nunca se mandan parámetros: tipo de terapia, motivo o datos del paciente son
 * datos de salud sensibles (Ley 19.628 / 21.719).
 */
export type MetaStandardEvent = 'Contact' | 'Lead' | 'Schedule';

export function trackMetaEvent(event: MetaStandardEvent) {
  // Espejo en GA4 desde el mismo punto de disparo, sin tocar los callers
  // (BookingWizard es módulo crítico). Tiene sus propias guardas.
  trackGaConversion(event);
  try {
    if (!window.fbq) return;
    if (getMarketingConsent() !== 'granted') return;
    if (!isMarketingPath(window.location.pathname)) return;
    window.fbq('track', event);
  } catch {
    // La medición nunca debe romper el flujo de la página.
  }
}
